import { Box, Button, Grid, Stack } from '@mui/material';
import CreateIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import { useContext } from 'react';
import { EditableContext } from '../../contexts/EditableContext';

interface EditToolsProps {
    onSave: () => void;
    onCreate: () => void;
}

const EditTools = ({ onSave, onCreate }: EditToolsProps) => {
    const isEditable = useContext(EditableContext);

    return (
        !isEditable ? <></> :
        <Grid container spacing={2} justifyContent="flex-end" style={{marginTop: '1em', marginBottom: '1em'}}>
            <Grid item xs={10}></Grid>
            <Grid item xs={2}>
                <Box display="flex" justifyContent="flex-end" className="tools">
                    <Stack spacing={2} direction="row">
                        <Button variant="contained" color='primary' onClick={onSave}>Save <SaveIcon /></Button> 
                        <Button variant="contained" color="secondary" onClick={onCreate}>Create <CreateIcon /></Button>
                    </Stack>
                </Box>
            </Grid>
        </Grid>
    )
};

export default EditTools;